/**
 * Tenant detection utilities for subdomain-based routing.
 *
 * Extracts tenant slug from the current hostname subdomain.
 * e.g., pes.ilmiq.com → "pes", ilmiq.com → null
 */

const MAIN_DOMAIN = "ilmiq.com";
const RESERVED_SUBDOMAINS = ["www", "api", "dev", "test", "dev-api", "test-api"];

/**
 * Extracts the tenant slug from the hostname.
 * Returns null if on the main domain, localhost, or a reserved subdomain.
 */
export function getTenantSlugFromHostname(
  hostname: string = window.location.hostname
): string | null {
  // localhost or IP addresses — no tenant
  if (hostname === "localhost" || hostname === "127.0.0.1" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }

  // Must end with the main domain
  if (!hostname.endsWith(`.${MAIN_DOMAIN}`)) {
    return null;
  }

  // Extract the subdomain part (everything before .ilmiq.com)
  const subdomain = hostname.slice(0, hostname.length - MAIN_DOMAIN.length - 1);

  // No subdomain or reserved subdomain
  if (!subdomain || RESERVED_SUBDOMAINS.includes(subdomain)) {
    return null;
  }

  return subdomain;
}

/**
 * Returns true if the current page is loaded from a tenant subdomain.
 */
export function isSubdomainLogin(): boolean {
  return getTenantSlugFromHostname() !== null;
}
